/**
 * Narrowing a loaded page in the browser, by customer name or rego.
 *
 * 🔑 One rule for every list that pages in hundreds and searches locally — the Queued
 * column, the split view's sidebar, the planner, the phone's job list, and the quotes
 * board's not-sent lane. The server is never asked: a page of a hundred or a thousand
 * cards is something a browser filters instantly, and the whole point of the box is to
 * find one thing on the page that is loaded. Case-insensitive substring on the two
 * fields a person actually knows about a car in the workshop.
 *
 * @template T
 * @param {T[]} items anything carrying `customerName` and `vehicleRego`
 * @param {string} search what was typed; blank means everything
 * @returns {T[]} the same array when the search is blank, else a filtered copy
 */
export function filterByNameOrRego(items, search) {
    const q = (search ?? '').trim().toLowerCase();
    if (!q) return items;
    return items.filter((item) =>
        (item?.customerName ?? '').toLowerCase().includes(q)
        || (item?.vehicleRego ?? '').toLowerCase().includes(q));
}

export default filterByNameOrRego;
